import AppBar from 'gridosComponents/AppBar';
import { MODULE_PATH, SETTINGS } from 'Heartbeat/routes/routes';
import { FEATURE_TOGGLES, useFeatureToggle } from 'sharedComponents/FeatureToggle';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { Chip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { defaultGridosMessage, defaultPlatformMessage, defaultUtilihiveMessage } from 'locales/defaultMessages';
import { useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLinkClickHandler, useLocation, useNavigate } from 'react-router';
import { signoutZitadel } from '../../actions/zitadel';
import { navRoutes } from '../../config/routes';

const NavigationBar = ({ organizationShortName, fetchFeatures, logout, modules }) => {
  const intl = useIntl();
  const foundation = useFeatureToggle(FEATURE_TOGGLES.FOUNDATION);

  const onProfileClick = useLinkClickHandler(`/${MODULE_PATH}/${SETTINGS}`);
  useEffect(() => {
    if (organizationShortName && !foundation) {
      fetchFeatures();
    }
  }, [fetchFeatures, organizationShortName, foundation]);
  const navigate = useNavigate();
  const location = useLocation();
  const current = location.pathname.split('/')[1];

  const routes = useMemo(
    () =>
      navRoutes
        .filter(route =>
          route.moduleNameForOrganisationAccess ? modules.includes(route.moduleNameForOrganisationAccess) : true
        )
        .map(({ path, intlMessage, external }) => ({
          path,
          label: intl.formatMessage(intlMessage),
          external,
        })),
    [intl, modules]
  );
  const onSelect = useCallback(
    e => {
      const selectedModule = routes.find(route => route.path === e.target.value);
      if (selectedModule.external) {
        globalThis.location.href = e.target.value;
      } else {
        navigate('/' + e.target.value);
      }
    },
    [navigate, routes]
  );

  const labels = useMemo(
    () => ({
      title: foundation ? intl.formatMessage(defaultGridosMessage) : intl.formatMessage(defaultUtilihiveMessage),
      product: foundation ? intl.formatMessage(defaultPlatformMessage) : '',
      userButton: intl.formatMessage({ id: 'Toasts-ThemeChange-action', defaultMessage: 'User settings' }),
      logout: {
        label: intl.formatMessage({ id: 'Logout-modalButton-confirmLogout', defaultMessage: 'Log out' }),
        confirmTitle: intl.formatMessage({ id: 'Logout-modalHeader-confirmLogout', defaultMessage: 'Confirm logout' }),
        confirmBody: intl.formatMessage({
          id: 'Logout-modalContent-confirmLogout',
          defaultMessage: 'Are you sure you want to log out?',
        }),
        confirmButton: intl.formatMessage({ id: 'Logout-modalButton-confirmLogout', defaultMessage: 'Log out' }),
      },
    }),
    [intl, foundation]
  );
  const devMode = import.meta.env.MODE === 'development';
  return (
    <AppBar
      modules={routes}
      currentModulePath={current}
      labels={labels}
      onLogout={foundation ? signoutZitadel : logout}
      onSelect={onSelect}
      Toolbar={
        <>
          {devMode && <Chip label="LOCAL DEV" color="primary" size="small" sx={{ ml: 2 }} />}
          <Tooltip title={labels.userButton}>
            <IconButton onClick={onProfileClick} sx={{ ml: 1 }} color="inherit">
              <AccountCircle />
            </IconButton>
          </Tooltip>
        </>
      }
    />
  );
};

export default NavigationBar;
